import {Accordion} from 'components/accordion';
import Swiper from 'swiper/js/swiper.min';
import {Utils} from 'common/scripts/utils';

// Расскрывающаяся текстовая версия
const storiesList = Array.from(document.querySelectorAll('.j-collapse-stories'));

storiesList.forEach((elem) => {
    new Accordion().init({
        elem,
        selectors: {
            toggler     : '.j-collapse-stories__link',
            content     : '.j-collapse-stories__text',
            contentOuter: '.j-collapse-stories__text-outer'
        }
    });
});

const storiesSection = Array.from(document.querySelectorAll('.j-stories-objects'));

const optionsStoriesSection = {
    wrapperClass : 'j-stories-objects-list',
    slideClass   : 'j-stories-objects-item',
    slidesPerView: 'auto',
    scrollbar    : {
        el       : '.j-stories-section-scrollbar',
        draggable: true
    }
};

let swiper = null;

const swiperStatus = () => {
    if (!Utils.isMobile() && storiesSection) {
        if (swiper) {
            swiper.forEach((element) => {
                return element.init();
            });
        } else {
            swiper = storiesSection.map((element) => {
                return new Swiper(element, optionsStoriesSection);
            });
        }
    } else if (swiper) {
        swiper.forEach((element) => {
            return element.destroy();
        });

        swiper = null;
    }
};

swiperStatus();

window.addEventListener('resize', () => {
    swiperStatus();
});
